import React from 'react';

import { Container, Typography } from "@mui/material";

const PrivacyPolicyPage = () => {
    return (
        <Container sx={{ my: "30px" }}>
            <Typography variant="h5" className='title'> ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ </Typography>
            <p>
                Дана угода про конфіденційність розроблено відповідно до вимог Закону України «Про захист
                персональних
                даних» та інших нормативних актів українського законодавства, що регламентують правові
                відносини,
                пов'язані
                зі збором, обробкою, зберіганням персональних даних, а також правом громадян на невтручання
                в особисте
                життя
                та правом на самовираження.

                Інтернет-магазин ТМ «SHOPERS_VI», піклуючись про розвиток взаємовідносин з клієнтами,
                розуміючи
                важливість
                забезпечення охорони Ваших персональних даних, з метою вирішення можливих протиріч і
                непорозумінь
                підготувало цю Угоду про конфіденційність (політику конфіденційності), далі за текстом -
                «Політика
                конфіденційності», і умови користування веб-сайтом Інтернет-магазину https://shopersvi.com.ua,
                далі по
                тексту -
                «сайт». Будь ласка, уважно прочитайте дану сторінку, тому що інформація, викладена на ній є
                важливою для
                Вас
                як для Користувача сайту.
            </p>

            <Typography variant="h5" className='subtitle'>
                1. ВИЗНАЧЕННЯ ТЕРМІНІВ
            </Typography>

            1.1 У даній Політиці конфіденційності використовуються такі терміни:<br />
            1.1.1. «Адміністрація сайту Інтернет-магазину (далі - Адміністрація сайту)» - уповноважені
            співробітники на
            управління сайтом, що діють від імені інтернет-магазину ТМ «SHOPERS_VI», які організовують
            обробку
            персональних даних, а також визначають цілі обробки персональних даних, склад персональних
            даних, які
            підлягають обробці, дії або операції, що здійснюються з персональними даними.<br />

            1.1.2. «Персональні дані» - будь-яка інформація, що стосується прямо або побічно до певної або
            визначаємої фізичної особи (суб'єкту персональних даних).<br />
            1.1.3. «Обробка персональних даних» - будь-яка дія (операція) або сукупність дій (операцій), що
            здійснюються з використанням засобів автоматизації або без використання таких засобів з
            персональними
            даними,
            включаючи збір, запис, систематизацію, накопичення, зберігання, уточнення (оновлення, зміна), витяг,
            використання,
            передачу (поширення, надання, доступ), знеособлення, блокування, видалення, знищення персональних
            даних.<br />
            1.1.4. «Конфіденційність персональних даних» - обов'язкове для дотримання Адміністратором або іншими
            отримавшими доступ до персональних даних особою вимога не допускати їх поширення без згоди суб'єкта
            персональних даних або наявності іншого законного підстави.<br />
            1.1.5. «Користувач сайту Інтернет-магазину ТМ« SHOPERS_VI »- особа, яка має доступ до Сайту, за
            допомогою мережі Інтернет і використовує Сайт інтернет-магазину.<br />
            1.1.6. «Cookies» - невеликий фрагмент даних, відправлений веб-сервером і зберігається на комп'ютері
            користувача, який веб-клієнт або веб-браузер кожен раз пересилає веб-серверу в HTTP-запиті при
            спробі відкрити сторінку відповідного сайту.<br />
            1.1.7. «IP-адреса» - унікальна мережева адреса вузла в комп'ютерній мережі, побудованої за
            протоколом
            IP.<br />

            <Typography variant="h5" className='subtitle'>
                2.ПРЕДМЕТ ПОЛІТИКИ КОНФІДЕНЦІЙНОСТІ
            </Typography>

            2.1. Користуючись сайтом або купуючи товар, пропонований на сайті, а також відповідаючи на необхідні
            питання
            в анкеті при реєстрації і або оформленні покупки, користувач підтверджує, що дає згоду
            Інтернет-магазину
            ТМ
            «SHOPERS_VI» і уповноваженим ним особам, на обробку персональних даних, а також що є повнолітньою
            особою.<br />

            2.2. Користувач дає свою згоду Адміністрації сайту на обробку отриманої інформації, включаючи збір,
            систематизацію, накопичення, зберігання, уточнення (оновлення, виправлення), використання,
            поширення,
            знеособлення, блокування, знищення персональних даних, зазначених в анкеті, з метою заходів,
            спрямованих
            на
            формування бази даних учасників, складання статистичної звітності, проведення маркетингових
            досліджень,
            а
            також здійснення взаємодії з користувачем, в тому числі по мережах електрозв'язку, включа я
            надсилання
            SMS-повідомлень і електронних листів, до відкликання такої згоди.<br />

            2.3. Користувач підтверджує свою згоду з тим, що Адміністрація сайту має право взаємодіяти з
            Користувачем
            шляхом здійснення прямих контактів за допомогою різних засобів зв'язку, включаючи, але не
            обмежуючись:
            поштова розсилка, електронна пошта, мережа Інтернет і ін.<br />

            2.4. Персональні дані, дозволені до обробки в рамках цієї Політики конфіденційності, включають в
            себе,
            але
            не обмежуються наступною інформацією:<br />

            2.4.1. ПІБ Користувача;<br />

            2.4.2. контактний телефон Користувача;<br />

            2.4.3. адреса електронної пошти (e-mail);<br />

            2.4.4. адреса доставки Товару;<br />

            2.4.5. місце проживання Користувача.<br />

            <Typography variant="h5" className='subtitle'>
                3.МЕТА ЗБОРУ ТА ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ
            </Typography>


            3.1. Персональну інформацію Користувача Інтернет-магазину ТМ «SHOPERS_VI» використовує для таких
            цілей:<br />

            3.1.1. ідентифікації Користувача, зареєстрованого на сайті Інтернет-магазину, для оформлення
            замовлення
            і
            (або) укладення Договору купівлі-продажу товару дистанційним способом з Інтернет-магазином ТМ
            «SHOPERS_VI».<br />

            3.1.2. надання Користувачеві ефективної клієнтської підтримки;<br />

            3.1.3. надання Користувачеві персоналізованих Сервісів;<br />

            3.1.4. зв'язку з Користувачем, в тому числі напрямок повідомлень, запитів та інформації, що
            стосуються
            використання Сервісів, надання послуг, а також обробки запитів і заявок від Користувача;<br />

            3.1.5. поліпшення якості Послуг, зручності їх використання, розробка нових Сервісів і послуг;<br />

            3.1.6. надання інформації про товари, послуги, що реалізуються ТМ «SHOPERS_VI», про рекламні акції,
            що
            проводяться ТМ «SHOPERS_VI», відповідей на запити, а також виконання ТМ «SHOPERS_VI» своїх
            зобов'язань
            перед
            споживачами товарів (послуг);<br />

            3.1.7. проведення статистичних та інших досліджень на основі знеособлених даних.<br />
            <Typography variant="h5" className='subtitle'>
                4.КАТЕГОРІІ ЗІБРАНИХ ДАНИХ
            </Typography>


            4.1.Категоріі Персональних даних, збір яких здійснює сайт (самостійно або за посередництвом третіх
            осіб),
            включають: <br />Файли «cookie» і Дані про використання мережевих ресурсів.<br />

            4.2. Персональні дані можуть надаватися Користувачем самостійно або їх збір може автоматично
            здійснювати
            сайт при його використанні.<br />

            Якщо не вказано інше, сайт https://shopersvi.com.ua використовує файли «cookie» (або інші засоби
            відстеження)
            для ідентифікації користувачів і запам'ятовування встановлених ними глобальних параметрів
            налаштування
            виключно в цілях надання послуги, що вимагається Користувачеві.

            4.3. Користувачі несуть відповідальність за Персональні дані третіх осіб, які вони отримують,
            публікують або надають іншим особам, використовуючи сайт, і підтверджують, що у них є згода третьої особи на
            надання Даних Власнику.<br />
            <Typography variant="h5" className='subtitle'>
                5. СПОСОБИ І ТЕРМІНИ ОБРОБКИ ПЕРСОНАЛЬНИХ ДАНИХ
            </Typography>

            5.1. Обробка персональних даних Користувача здійснюється без обмеження терміну, будь-яким законним
            способом,
            в тому числі в інформаційних системах персональних даних з використанням засобів автоматизації або
            без
            використання таких засобів.<br />

            5.2. Користувач погоджується з тим, що Адміністрація сайту має право передавати персональні дані
            третім
            особам, зокрема, кур'єрським службам, організаціями поштового зв'язку, операторам електрозв'язку,
            виключно з
            метою виконання замовлення Користувача, оформленого на Сайті Інтернет-магазину ТМ «SHOPERS_VI»,
            включаючи
            доставку Товару.<br />

            <Typography variant="h5" className='subtitle'>
                6. ПРАВА КОРИСТУВАЧІВ
            </Typography>


            6.1. Користувачі мають право:<br />

            6.1.1. дізнатися, чи були збережені їх Персональні дані<br />

            6.1.2. звертатися до Адміністрації сайту, щоб дізнатися їх зміст і походження<br />

            6.1.3. перевірити їх достовірність, або попросити їх доповнити<br />

            6.1.4. видалити, оновити або виправити<br />

            6.1.5. перетворити в формат, що забезпечує анонімність<br />

            6.1.6. блокувати будь-які дані, що зберігаються в порушення закону<br />

            6.1.7 виступити проти їх обробки за всіма без винятку законних підставах.<br />

            6.2. Відповідні запити слід направляти адміністрації сайту за адресою, вказаною в контактних
            відомостях на сайті.<br />
            <Typography variant="h5" className='subtitle'>
                7. ПОЛІТИКА ЩОДО ФАЙЛІВ COOKIE
            </Typography>


            7.1. Сайт збирає інформацію про відвідування Вами наших веб-сайтів з метою отримання статистики
            відвідувань
            і ефективності їх використання, формування персонального підходу і адаптації до інтересів кожного
            користувача. Ми робимо це за допомогою різних технологій, одна з яких - cookie-файли. Це дані, які
            веб-сайт
            може відправити вашому браузеру, і вони будуть збережені на вашому комп'ютері для подальшої
            ідентифікації
            його веб-сайтом.<br />

            7.2. Cookie-файли використовуються для оцінки ефективності веб-сайтів (наприклад, для вимірювання
            кількості
            відвідувачів і тривалості їх перебування на сайті), виявлення найбільш цікавих і відвідуваних тем і
            сторінок, а також для забезпечення зручності навігації та користування сайтом, без збору будь-якої
            персональної інформації. Також cookie-файли можуть бути використані для формування персонального
            підходу
            на
            основі вже наявного досвіду взаємодії користувача з сайтом і його перевагами. З плином часу ця
            інформація
            дозволяє поліпшити досвід.<br />
            <Typography variant="h5" className='subtitle'>
                8. БЕЗПЕКА ПЕРСОНАЛЬНИХ ДАНИХ
            </Typography>

            8.1. Інтернет-магазин ТМ «SHOPERS_VI» приймає необхідні організаційні та технічні заходи для захисту
            персональної інформації Користувача від неправомірного або випадкового доступу, знищення,
            перекручення,
            блокування, копіювання, поширення, а також від інших неправомірних дій третіх осіб.<br />

            8.2. Дана Політика конфіденційності поширюється тільки на сайті Інтернет-магазину ТМ «SHOPERS_VI».
            Якщо
            за
            посиланнями, розміщеними на сайті останнього, Користувач зайде на ресурси третіх осіб,
            Інтернет-магазин
            за
            його дії відповідальності не несе.<br />

            8.3. Персональні дані Користувача можуть бути використані в юридичних цілях в суді або на етапах, що
            ведуть
            до можливого звернення до суду в зв'язку з тим, що сайт або послуги використовувалися неналежним
            чином.<br />

            Користувач обізнаний про те, що адміністарції сайту може бути змушена повідомити персональні дані на
            вимогу
            органів державної влади.<br />

            <Typography variant="h5" className='subtitle'>
                9. ДОДАТКОВА ІНФОРМАЦІЯ ПРО ПЕРСОНАЛЬНІ ДАНІ КОРИСТУВАЧА
            </Typography>

            9.1. Крім інформації, що міститься в цих правилах забезпечення конфіденційності персональних даних,
            сайт
            може надавати Користувачу за запитом додаткову і контекстуальну інформацію, що стосується конкретних
            послуг
            і сервісів або збору і обробки Персональних даних.<br />

            9.2. З метою забезпечення роботи сайту та його технічного обслуговування, сайт і будь-які сторонні
            сервіси
            можуть вести файли, в яких реєструється взаємодія сайту з Користувачами (системні журнали), або
            використовувати з цією метою інші Персональні дані (зокрема, IP-адреса).<br />

            <Typography variant="h5" className='subtitle'>
                10. ДОДАТКОВІ УМОВИ
            </Typography>

            10.1. Адміністрація сайту має право вносити зміни в справжню Політику конфіденційності без згоди
            Користувача.<br />

            10.2. Нова Політика конфіденційності вступає в силу з моменту її розміщення на Сайті
            інтернет-магазину,
            якщо
            інше не передбачено новою редакцією Політики конфіденційності.<br />

            10.3. У разі незгоди з будь-якими змінами, внесеними до Правил, Користувач повинен припинити
            користуватися
            сайтом, а також вимагати, щоб адміністрація сайту даних видалила його Персональні дані.<br />
        </Container>
    );
};

export {
    PrivacyPolicyPage
};